const SvgRegex = (props) => (
  <svg height="1em" viewBox="0 0 16 15" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-2h18v18H0z" />
      <path d="M0 12.917h1.5" stroke="currentColor" strokeWidth={1.5} />
      <path
        d="M3.336 3.652l12 6.928M3.337 10.58l12-6.927M9.336 14.045V.188"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default SvgRegex
